<template>
    <footer class="responsabilityFooter px-10 py-10 d-flex flex-column justify-center align-center">
      <div class="d-flex flex-column justify-center align-center">
        <!--<h2 class="mb-4">{{footerTitle}}</h2>
        <MarkdownBlock v-if="footerSubtitle" class="footerSubtitle mt-4 d-none d-sm-block" :text="footerSubtitle"/>
        <DiscoverButton high-visibility is-white :to="{params: {internal: discoverUrl}}" />-->
        <router-link class="mt-16 mb-2 link" :to="{name: 'Designers'}">{{$root.siteSettings.backToDesignersPageLabel}}</router-link>
        <hr/>
        <router-link :to="{name: 'Designers'}"><h3 class="mt-8 mb-16">{{$root.siteSettings.designersPageTitle}}</h3></router-link>
      </div>
    </footer>
</template>

<script>
import Section from '@/constants/responsabilitySection'

export default {
  name: 'DesignersResponsibilityFooter',
  props: {
    responsabilityData: {
      type: Object
    },
    currentSection: {
      type: String
    },
    bg: {
      type: String
    }
  },
  data () {
    return {
      section: Section
    }
  },
  computed: {
    footerTitle () {
      return (this.currentSection === Section.consciuousDesigner) ? this.responsabilityData.howtoTitle : this.responsabilityData.consciousnessDesignersTitle
    },
    footerSubtitle () {
      return (this.currentSection === Section.consciuousDesigner) ? this.responsabilityData.howtoSubtitle : this.responsabilityData.consciousnessDesignersSubtitle
    },
    footerStyleObj () {
      return {
        backgroundImage: `url(${this.bg})`
      }
    },
    discoverUrl () {
      return this.currentSection === Section.consciuousDesigner ? Section.howTO : Section.consciuousDesigner
    }
  }
}
</script>

<style scoped lang="scss">
  .responsabilityFooter {
    width: 100%;
    min-height: 320px;
    background-color: #131313;
    color: #131313;
    background-size: cover;

    hr {
      width: 50px;
      border-color: $c-pink;
    }

    div {
      width: 50%;
      text-align: center;
    }

    .link {
      color: $c-pink;
    }

    h3 {
      color: #4e4e4e;;
    }

    /*h2 {
      font-family: $heading-font-family;
      color: $c-pink;
      max-width: 50%;
      font-size: 5.8vh;
      line-height: 1;
    }*/

    /*.footerSubtitle {
      max-width: 500px;
    }*/
  }
</style>
